// src/components/marketing/marketing-recursos.js
// =======================================================================
// As ARTES e as FONTES que as telas do Marketing desenham no canvas.
// =======================================================================
// ⚠️⚠️ AS ARTES SÃO ARQUIVO, NÃO BASE64 DENTRO DO CÓDIGO. Nas ferramentas
//    originais a imagem de fundo vinha embutida em base64 no HTML — era o que
//    fazia o gerador de vagas ter **2,3 MB** (o código eram ~400 linhas). Aqui
//    elas moram em `public/marketing/` e o navegador as busca uma vez e guarda
//    em cache; trocar a arte passa a ser substituir um arquivo.
//
// ⚠️ AS FONTES SÃO CARREGADAS SOB DEMANDA. O portal já carrega Poppins no
//    `index.html`; Fredoka e Space Grotesk existem só nestas duas artes, então
//    entram por um `<link>` injetado quando a tela abre — e não no arquivo
//    global, que todo mundo paga.
// ⚠️⚠️ E É PRECISO ESPERAR A FONTE CARREGAR ANTES DE DESENHAR: o canvas não
//    re-renderiza sozinho quando a fonte chega. Sem o `document.fonts.load`, a
//    arte sai desenhada na fonte substituta — em silêncio, e só quem conhece a
//    arte percebe.
// =======================================================================

export const ARTE_CONTRATACAO = `${process.env.PUBLIC_URL || ''}/marketing/arte-contratacao.jpg`;
export const ANIVERSARIANTES_FUNDO = `${process.env.PUBLIC_URL || ''}/marketing/aniversariantes-fundo.png`;
export const ANIVERSARIANTES_TITULO = `${process.env.PUBLIC_URL || ''}/marketing/aniversariantes-titulo.png`;

const LINK_FONTES_ID = 'marketing-fontes-artes';
const LINK_FONTES_HREF =
    'https://fonts.googleapis.com/css2?family=Fredoka:wght@500;600;700&family=Space+Grotesk:wght@400;500;700&display=swap';

/** Injeta (uma vez) o `<link>` das fontes usadas só nas artes do Marketing. */
function garantirLinkDasFontes() {
    if (document.getElementById(LINK_FONTES_ID)) return;
    const link = document.createElement('link');
    link.id = LINK_FONTES_ID;
    link.rel = 'stylesheet';
    link.href = LINK_FONTES_HREF;
    document.head.appendChild(link);
}

/**
 * Espera as fontes pedidas ficarem prontas para desenhar no canvas.
 * @param {string[]} faces  ex.: ["700 19px Fredoka", "700 20px Poppins"]
 */
export async function carregarFontes(faces) {
    garantirLinkDasFontes();
    if (!document.fonts || !document.fonts.load) return;
    try {
        await Promise.all(faces.map((f) => document.fonts.load(f)));
        await document.fonts.ready;
    } catch {
        // Fonte que não carrega (rede do escritório bloqueando o Google Fonts)
        // não pode derrubar a tela: a arte sai na fonte substituta, feia mas
        // utilizável, e quem está gerando vê na hora.
    }
}

/** Carrega uma imagem e devolve o elemento pronto para o `drawImage`. */
export function carregarImagem(src) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error(`Não foi possível carregar a arte: ${src}`));
        img.src = src;
    });
}

/**
 * Baixa um blob com o nome dado. É o caminho ÚNICO de download destas telas —
 * as ferramentas originais tinham um plano B ("salve com o botão direito")
 * porque rodavam dentro de uma pré-visualização que bloqueava download; dentro
 * do portal isso não existe.
 */
export function baixarArquivo(nome, blob) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = nome;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}
